const styles = {
  LOGIN_CONTAINER: { 
    backgroundImage: 'url("https://www.app.linkplease.co/assests/bg.svg")',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    width: '100%'
  },
  LOGIN_WRAPPER: {
    width: '470px',
    display: 'flex',
    justifyContent: 'center',
  },
  LOGIN_FORM: {
    border: '1px solid #CCCCCC',
    borderRadius: '4rem',
    padding: '3rem',
    backgroundColor: '#FFFFFF',
    width: '100%',
  },
  LOGIN_LOGO_WRAPPER: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  LOGIN_TEXT_H1: {
    color: '#2D2D2D',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '0.25rem',
  },
  LOGIN_TEXT_P_BOLD: {
    color: '#4B4B4B',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    marginBottom: '1.75rem',
  },
  LOGIN_INPUT_WRAPPER: {
    marginBottom: '1rem',
  },
  LOGIN_INPUT: {
    width: '100%',
    padding: '1rem',
    border: '1px solid #E5E7EB',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    outline: 'none',
    '&:focus': {
      borderColor: '#7772FF',
    },
  },
  LOGIN_BUTTON_SUBMIT: {
    width: '100%',
    padding: '1rem',
    backgroundColor: '#7772FF',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  LOGIN_FORGOT_PASSWORD: {
    color: '#7772FF',
    fontSize: '0.875rem',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  LOGIN_TEXT_LINK: {
    color: '#7772FF',
    cursor: 'pointer',
    fontWeight: 'bold',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default styles;